export enum HotKeyChannels {
  HOTKEY_EVENT = 'hotkey-event',
  // Push-to-dictate. The rest of the former key list was removed with the dead global
  // shortcuts in hotKeys.ts; add an entry back only when a renderer listener needs it.
  F1 = 'F1',
  /** Pause / resume the recording in progress, without ending it. */
  F3 = 'F3',
}
